import { render, staticRenderFns } from "./amocrm_logo.vue?vue&type=template&id=e2427394&functional=true&"
import script from "./amocrm_logo.vue?vue&type=script&lang=js&"
export * from "./amocrm_logo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports